module.exports = __webpack_public_path__ + "static/media/bad.281e1c69.gif";